import { render, staticRenderFns } from "./MappingFit.vue?vue&type=template&id=2fa6e184&"
import script from "./MappingFit.vue?vue&type=script&lang=js&"
export * from "./MappingFit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports